'use strict';

function getOfferRedemptionData(data) {
  const {
    offerId,
    offerTitle,
    offerType,
    offerCode,
    expiryDateTime,
    termsAndConditions,
    financialTerms,
    isLimitedGlobally,
    isLimitedPerUser,
  } = data;
  const { merchantId, merchantName, merchantMedia } = data.merchant || {};

  return {
    offerId,
    offerTitle,
    offerType,
    offerCode,
    expiryDateTime,
    termsAndConditions,
    financialTerms,
    isLimited: isLimitedGlobally || isLimitedPerUser,
    type: 'TERMS',
    merchantId,
    merchantName,
    merchantMedia,
  };
}

function getReferralSource({ referralSource, offerId, directRedemption }) {
  const directOfferId = directRedemption && directRedemption.offerId;

  if (referralSource === 'email' && directOfferId !== offerId) {
    return '';
  }

  return referralSource;
}

module.exports = { getOfferRedemptionData, getReferralSource };
